import { render, staticRenderFns } from "./t-orm-menu-actions.vue?vue&type=template&id=9cb3fa3a&scoped=true&lang=pug"
import script from "./t-orm-menu-actions.vue?vue&type=script&lang=js"
export * from "./t-orm-menu-actions.vue?vue&type=script&lang=js"
import style0 from "./t-orm-menu-actions.vue?vue&type=style&index=0&id=9cb3fa3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb3fa3a",
  null
  
)

export default component.exports